module.exports = __webpack_public_path__ + "static/media/gift_pl_one.921d3235.png";